/**
 * Codigos que el backend conoce. Ningun literal de estos debe repetirse
 * dentro de los componentes.
 */

// Tipos de solicitud (genericas del modulo)
export const TIPO_LIBROS = "Bib_Lib";
export const TIPO_ARIA = "Bib_Cap";

// Actividades que habilitan cada pantalla en el sidebar
export const ACTIVIDAD_BIBLIOTECA = "biblioteca_act";
export const ACTIVIDAD_GESTION_BIBLIOTECA = "biblioteca_adm_act";

// Perfil del auxiliar de biblioteca (cargar_perfiles_biblioteca.sql): en el
// Calendario entra directo a "Mi agenda".
export const PERFIL_AUXILIAR_BIBLIOTECA = "Per_Aux_Bib";

// Azul del modulo (2026-10-15): los dias marcados de un horario y las
// solicitadas en el calendario.
export const AZUL_BIBLIOTECA = "#4094D7";

// Estado inicial: el unico en el que el solicitante todavia puede editar.
export const ESTADO_SOLICITADA = "Bib_Sol_E";

// Estados finales: la solicitud ya no se mueve ni se cancela. Es
// ESTADOS_CERRADOS en el backend.
export const ESTADOS_CERRADOS = ["Bib_Fin_E", "Bib_Rec_E", "Bib_Can_E"];

// Con los libros ya entregados el solicitante no puede cancelar.
export const ESTADO_ENTREGADA = "Bib_Ent_E";

// Generica del periodo academico vigente para biblioteca
export const CODIGO_PERIODO = "Per_Bib";

export const ESTADO_ACTIVO = 1;

// Pestañas
export const VISTA_SOLICITANTE = {
  PROCESOS: "miproceso",
  NUEVO: "nuevo",
};

// Pestañas del modal de mas informacion de una solicitud
export const VISTA_DETALLE = {
  SOLICITUD: "solicitud",
  ESTUDIANTES: "estudiantes",
  MATERIAL: "material",
  EJEMPLARES: "ejemplares",
  AUXILIARES: "auxiliares",
  HISTORIAL: "historial",
};

// Pestañas del modal Gestionar de una solicitud, como en Gestion Practicas
export const VISTA_GESTIONAR = {
  GESTIONAR: "gestionar",
  AUXILIARES: "auxiliares",
  EJEMPLARES: "ejemplares",
};

// Pestañas de Gestion Biblioteca, como las de Gestion Practicas
export const VISTA_GESTION = {
  PROCESOS: "procesos",
  CALENDARIO: "calendario",
  ADMINISTRAR: "administrar",
};

// Rutas del modulo
export const RUTA_BIBLIOTECA = "/biblioteca";
export const RUTA_GESTION_BIBLIOTECA = "/gestion_biblioteca";

// Endpoints del backend. Procesos trabaja con las solicitudes propias;
// Gestion, con las de todos (solo para quien administra el modulo).
export const API_SOLICITUDES = "api/v1.0/biblioteca/solicitudes";
export const API_GESTION = "api/v1.0/biblioteca/gestion";

// Buscador de personas de Emma, compartido con becas, bienestar y los demas
// modulos. El servidor no busca con menos de 4 caracteres.
export const API_BUSCAR_PERSONAS = "api/v1.0/personas/buscar";
export const MINIMO_BUSQUEDA = 4;

// Identidad por cedula. Detras esta IDCUC, el servicio de identidades de la
// universidad: reconoce a cualquiera que tenga cuenta CUC, exista o no en
// Emma. Es el mismo que usa el boton de lupa de Nueva Persona.
export const API_BUSCAR_IDENTIDAD = "api/v1.0/personas/buscar_persona";

// Ids de genericas. El valor por defecto es el de Emma test; las variables de
// entorno solo hacen falta donde cambian (la BD local, ver docker-compose.yml).
// Se leen al compilar: cambiarlas exige reiniciar el contenedor.
const idDeEntorno = (valor, porDefecto) => {
  const id = Number(valor);
  return Number.isInteger(id) && id > 0 ? id : porDefecto;
};

// Bloques: sus salones salen de la relacion bloque -> salon (tabla de
// permisos), igual que en el AGIL viejo.
export const GENERICA_BLOQUES = idDeEntorno(
  process.env.REACT_APP_GENERICA_BLOQUES_BIBLIOTECA,
  231,
);

// Salones: de la relacion de un bloque solo se toman los valores de esta
// generica. El backend valida con la misma (GENERICA_SALAS_BIBLIOTECA).
export const GENERICA_SALAS = idDeEntorno(
  process.env.REACT_APP_GENERICA_SALAS_BIBLIOTECA,
  232,
);

export const GENERICA_NIVELES_ARIA = idDeEntorno(
  process.env.REACT_APP_GENERICA_NIVELES_ARIA,
  420,
);
